import {
    StyledLoanTableContentBase,
    StyledLoansTableMarketingOfferContentBase,
} from './LoansTableContentBase.styled'

interface ContentBaseProps {
    children: React.ReactNode
    layoutVariant: 'ocean' | 'marketing' | 'default'
}

const LoansTableContentBase = ({
    layoutVariant,
    children,
}: ContentBaseProps) => {
    if (layoutVariant === 'marketing' || layoutVariant === 'ocean') {
        return (
            <StyledLoansTableMarketingOfferContentBase
                display="grid"
                gridTemplateColumns={[
                    '1fr',
                    'repeat(3, 1fr)',
                    'repeat(6, 1fr)',
                ]}
                gridColumnGap={['space10', 'space20', 'space10']}
                gridRowGap={['space10', 'space60', 'space10']}
                pb={[0, 0, 'space30']}
                pr={[0, 0, 'space20']}
            >
                {children}
            </StyledLoansTableMarketingOfferContentBase>
        )
    }

    return (
        <StyledLoanTableContentBase
            display="flex"
            flexDirection={['column', 'row']}
            maxHeight={['unset', '150px']}
            gridGap={['space10', 'space20']}
            pb={[0, 'space30']}
            pr={[0, 0, 'space20']}
        >
            {children}
        </StyledLoanTableContentBase>
    )
}

export default LoansTableContentBase
